var $570d6165ce6d2ee3$exports = {};
$570d6165ce6d2ee3$exports = {
    "collapse": `Comprimi`,
    "columnResizer": `Ridimensionamento colonne`,
    "drag": `Trascina`,
    "expand": `Espandi`,
    "loading": `Caricamento...`,
    "loadingMore": `Caricamento altri...`,
    "resizeColumn": `Ridimensiona colonna`,
    "sortAscending": `Ordinamento crescente`,
    "sortDescending": `Ordinamento decrescente`
};


export {$570d6165ce6d2ee3$exports as default};
//# sourceMappingURL=it-IT.mjs.map
